import * as React from 'react';
import { Link } from 'react-router-dom';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import AnalyticsRoundedIcon from '@mui/icons-material/AnalyticsRounded';
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import { useParams, Outlet } from "react-router-dom";
import { useContext } from "react";
import { EventContext } from '../../pages/Dashboard';

const mainListItems = [
  { text: 'Home', icon: <HomeRoundedIcon /> , link:''},
  { text: 'Description', icon: <AssignmentRoundedIcon />,  link:'admin' },
  { text: 'Posts', icon: <AnalyticsRoundedIcon />,  link:'posts' },
  { text: 'Speakers', icon: <PeopleRoundedIcon />,  link:'speakers' },
  { text: 'People', icon: <PeopleRoundedIcon />,  link:'people' },
  { text: 'Sponsors', icon: <AssignmentRoundedIcon />,  link:'sponsors' },
  { text: 'Maps', icon: <AssignmentRoundedIcon />,  link:'admin' },
  { text: 'Scheduler', icon: <AssignmentRoundedIcon />,  link:'scheduler' },
  { text: 'Tickets', icon: <AssignmentRoundedIcon />,  link:'tickets' },
];

const secondaryListItems = [
  { text: 'Settings', icon: <SettingsRoundedIcon />,  link:'settings' },
  { text: 'About', icon: <InfoRoundedIcon />,  link:'/' },
  { text: 'Feedback', icon: <HelpRoundedIcon />,  link:'/' },
];

export default function MenuContent() {

  const { eventDetails } = useContext(EventContext);
  const eventCode = eventDetails?.eventCode;
  
  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>     
      <List dense>
        {mainListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }} button component={Link} to={`/admin/${eventCode}/${item.link}`}>
            <ListItemButton selected={index === 0}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      
      <List dense>
        {secondaryListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }} button component={Link} to={`/admin/${eventCode}/${item.link}`}>
            <ListItemButton>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
}
